import React, { useState, useEffect } from 'react';
import clsx from "clsx";
import { isMobile } from '../../tools/is-mobile';
import './_index.scss';

const LimitBanner = () => {
  const [show, setShow] = useState(false);
  
  const bannerClasses = clsx({
    'limitBanner__content': true,
    'limitBanner__content--mobile': isMobile
  });
  
  const onCloseLimitBanner = () => {
    setShow(false);
  };
  
  useEffect(() => {
    const onShowLimitBanner = () => {
      setShow(true);
    };
  
    document.addEventListener('onShowLimitBanner', onShowLimitBanner);
  
    return () => {
      document.removeEventListener('onShowLimitBanner', onShowLimitBanner);
    };
  });
  
  return (show) ?  (
    <div className="limitBanner">
      <section className={bannerClasses}>
        <h2>Нельзя изменить количество льготного товара</h2>
        <p>Если нужно больше или меньше упаковок, можно оформить отдельный заказ по&nbsp;полной стоимости</p>
        <button
          className="btn btn-primary limitBanner__btn"
          onClick={onCloseLimitBanner}>Хорошо</button>
        <button
          className="limitBanner__close"
          aria-label="close"
          onClick={onCloseLimitBanner}
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L7 7M13 13L7 7M7 7L13 1M7 7L1 13" stroke="#9199A3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </section>
    </div>
  ) : null;
};

export default LimitBanner;